export const validarCUIT = (cuit) => {
  if (!cuit) return false;
  const cuitLimpio = cuit.replace(/[-\s]/g, "");
  if (cuitLimpio.length !== 11) return false;

  const [checkDigit, ...rest] = cuitLimpio.split("").reverse();
  const total = rest.reduce(
    (acc, cur, index) => acc + cur * [2, 3, 4, 5, 6, 7][index % 6],
    0,
  );

  const mod11 = 11 - (total % 11);
  const computedCheckDigit = mod11 === 11 ? 0 : mod11 === 10 ? 9 : mod11;

  return parseInt(checkDigit) === computedCheckDigit;
};
